import React from 'react';
import _ from 'lodash';

import { WorkerRadioText } from '../WorkerRadioText';

import { EXISTANCE_FLAG } from '../../../utilities/constants';
import { getTextExistanceFlagValue } from '../../../utilities/constantsUtil';

import {
  FormElement,
  FormList,
  FormListItem,
  FormListSubHeader,
} from '../../CommonFormComponents';
import { RadioButtonIcon } from '../../icons/RadioButtonIcon';
import { WorkerInputText } from '../WorkerInputText';

const RadioText = ({ name, value, disabled }) => {
  return (
    <WorkerRadioText
      name={name}
      value={getTextExistanceFlagValue(value)}
      disabled={disabled}
    />
  );
};

/**
 * 作業員編集 画面 > 既往症
 */
const AnamnesesForm = ({ events, formValues, messages, disabledAll }) => {
  if (messages.anamneses) {
    messages = messages.anamneses;
  }
  const FormRadio = ({ label, name, events, value, checked, disabled }) => (
    <div className='form-list-radio__item'>
      <label className='radio'>
        <input
          name={name}
          type='radio'
          checked={checked}
          value={value}
          onChange={e => {
            events.setValueAnamneses(e.target.name, Number(e.target.value));
          }}
          disabled={disabled}
        />
        <RadioButtonIcon className='icon--2x' />
        <span>{label}</span>
      </label>
    </div>
  );

  const TitleElement = ({ title, noMarginTop }) => (
    <FormListSubHeader title={title} noMarginTop={noMarginTop} />
  );

  return (
    <div className='contruction-detail-view__main contruction-detail-view__main--fixed contruction-detail-view__main--fix'>
      <FormList>
        <TitleElement title='既往症' noMarginTop={true} />
        <FormListItem label='既往症有無' safetyDocItem={true}>
          <FormElement>
            {disabledAll ? (
              <RadioText
                name='common'
                value={formValues.anamnesis_type}
                disabled={true}
              />
            ) : (
              <div className='form-list-radio'>
                {_.map(EXISTANCE_FLAG, (item, i) => {
                  return (
                    <FormRadio
                      key={`anamnesis_type${String(i)}`}
                      label={item.TEXT}
                      name='anamnesis_type'
                      value={item.VALUE}
                      events={events}
                      checked={formValues.anamnesis_type === item.VALUE}
                      disabled={false}
                    />
                  );
                })}
              </div>
            )}
          </FormElement>
        </FormListItem>

        {formValues.anamnesis_type !== EXISTANCE_FLAG.EXIST.VALUE ? null : (
          <FormListItem label='高血圧' safetyDocItem={true}>
            <FormElement>
              {disabledAll ? (
                <RadioText
                  name='common'
                  value={formValues.anamnesis_detail_type_high_blood_pressure}
                  disabled={true}
                />
              ) : (
                <div className='form-list-radio'>
                  {_.map(EXISTANCE_FLAG, (item, i) => {
                    return (
                      <FormRadio
                        key={`anamnesis_detail_type_high_blood_pressure${String(
                          i
                        )}`}
                        label={item.TEXT}
                        name='anamnesis_detail_type_high_blood_pressure'
                        value={item.VALUE}
                        events={events}
                        checked={
                          formValues.anamnesis_detail_type_high_blood_pressure ===
                          item.VALUE
                        }
                        disabled={false}
                      />
                    );
                  })}
                </div>
              )}
            </FormElement>
          </FormListItem>
        )}

        {formValues.anamnesis_type !== EXISTANCE_FLAG.EXIST.VALUE ? null : (
          <FormListItem label='低血圧' safetyDocItem={true}>
            <FormElement>
              {disabledAll ? (
                <RadioText
                  name='common'
                  value={formValues.anamnesis_detail_type_low_blood_pressure}
                  disabled={true}
                />
              ) : (
                <div className='form-list-radio'>
                  {_.map(EXISTANCE_FLAG, (item, i) => {
                    return (
                      <FormRadio
                        key={`anamnesis_detail_type_low_blood_pressure${String(
                          i
                        )}`}
                        label={item.TEXT}
                        name='anamnesis_detail_type_low_blood_pressure'
                        value={item.VALUE}
                        events={events}
                        checked={
                          formValues.anamnesis_detail_type_low_blood_pressure ===
                          item.VALUE
                        }
                        disabled={false}
                      />
                    );
                  })}
                </div>
              )}
            </FormElement>
          </FormListItem>
        )}

        {formValues.anamnesis_type !== EXISTANCE_FLAG.EXIST.VALUE ? null : (
          <FormListItem label='狭心症' safetyDocItem={true}>
            <FormElement>
              {disabledAll ? (
                <RadioText
                  name='common'
                  value={formValues.anamnesis_detail_type_angina_pectoris}
                  disabled={true}
                />
              ) : (
                <div className='form-list-radio'>
                  {_.map(EXISTANCE_FLAG, (item, i) => {
                    return (
                      <FormRadio
                        key={`anamnesis_detail_type_angina_pectoris${String(
                          i
                        )}`}
                        label={item.TEXT}
                        name='anamnesis_detail_type_angina_pectoris'
                        value={item.VALUE}
                        events={events}
                        checked={
                          formValues.anamnesis_detail_type_angina_pectoris ===
                          item.VALUE
                        }
                        disabled={false}
                      />
                    );
                  })}
                </div>
              )}
            </FormElement>
          </FormListItem>
        )}

        {formValues.anamnesis_type !== EXISTANCE_FLAG.EXIST.VALUE ? null : (
          <FormListItem label='糖尿病' safetyDocItem={true}>
            <FormElement>
              {disabledAll ? (
                <RadioText
                  name='common'
                  value={formValues.anamnesis_detail_type_diabetes}
                  disabled={true}
                />
              ) : (
                <div className='form-list-radio'>
                  {_.map(EXISTANCE_FLAG, (item, i) => {
                    return (
                      <FormRadio
                        key={`anamnesis_detail_type_diabetes${String(i)}`}
                        label={item.TEXT}
                        name='anamnesis_detail_type_diabetes'
                        value={item.VALUE}
                        events={events}
                        checked={
                          formValues.anamnesis_detail_type_diabetes ===
                          item.VALUE
                        }
                        disabled={false}
                      />
                    );
                  })}
                </div>
              )}
            </FormElement>
          </FormListItem>
        )}

        {formValues.anamnesis_type !== EXISTANCE_FLAG.EXIST.VALUE ? null : (
          <FormListItem label='難聴' safetyDocItem={true}>
            <FormElement>
              {disabledAll ? (
                <RadioText
                  name='common'
                  value={formValues.anamnesis_detail_type_hearing_loss}
                  disabled={true}
                />
              ) : (
                <div className='form-list-radio'>
                  {_.map(EXISTANCE_FLAG, (item, i) => {
                    return (
                      <FormRadio
                        key={`anamnesis_detail_type_hearing_loss${String(i)}`}
                        label={item.TEXT}
                        name='anamnesis_detail_type_hearing_loss'
                        value={item.VALUE}
                        events={events}
                        checked={
                          formValues.anamnesis_detail_type_hearing_loss ===
                          item.VALUE
                        }
                        disabled={false}
                      />
                    );
                  })}
                </div>
              )}
            </FormElement>
          </FormListItem>
        )}

        {formValues.anamnesis_type !== EXISTANCE_FLAG.EXIST.VALUE ? null : (
          <FormListItem label='夜盲症' safetyDocItem={true}>
            <FormElement>
              {disabledAll ? (
                <RadioText
                  name='common'
                  value={formValues.anamnesis_detail_type_night_blindness}
                  disabled={true}
                />
              ) : (
                <div className='form-list-radio'>
                  {_.map(EXISTANCE_FLAG, (item, i) => {
                    return (
                      <FormRadio
                        key={`anamnesis_detail_type_night_blindness${String(
                          i
                        )}`}
                        label={item.TEXT}
                        name='anamnesis_detail_type_night_blindness'
                        value={item.VALUE}
                        events={events}
                        checked={
                          formValues.anamnesis_detail_type_night_blindness ===
                          item.VALUE
                        }
                        disabled={false}
                      />
                    );
                  })}
                </div>
              )}
            </FormElement>
          </FormListItem>
        )}

        {formValues.anamnesis_type !== EXISTANCE_FLAG.EXIST.VALUE ? null : (
          <FormListItem label='馬鞭式創傷綜合症' safetyDocItem={true}>
            <FormElement>
              {disabledAll ? (
                <RadioText
                  name='common'
                  value={formValues.anamnesis_detail_type_whiplash_syndrome}
                  disabled={true}
                />
              ) : (
                <div className='form-list-radio'>
                  {_.map(EXISTANCE_FLAG, (item, i) => {
                    return (
                      <FormRadio
                        key={`anamnesis_detail_type_whiplash_syndrome${String(
                          i
                        )}`}
                        label={item.TEXT}
                        name='anamnesis_detail_type_whiplash_syndrome'
                        value={item.VALUE}
                        events={events}
                        checked={
                          formValues.anamnesis_detail_type_whiplash_syndrome ===
                          item.VALUE
                        }
                        disabled={false}
                      />
                    );
                  })}
                </div>
              )}
            </FormElement>
          </FormListItem>
        )}

        {formValues.anamnesis_type !== EXISTANCE_FLAG.EXIST.VALUE ? null : (
          <FormListItem label='腰痛' safetyDocItem={true}>
            <FormElement>
              {disabledAll ? (
                <RadioText
                  name='common'
                  value={formValues.anamnesis_detail_type_lumbago}
                  disabled={true}
                />
              ) : (
                <div className='form-list-radio'>
                  {_.map(EXISTANCE_FLAG, (item, i) => {
                    return (
                      <FormRadio
                        key={`anamnesis_detail_type_lumbago${String(i)}`}
                        label={item.TEXT}
                        name='anamnesis_detail_type_lumbago'
                        value={item.VALUE}
                        events={events}
                        checked={
                          formValues.anamnesis_detail_type_lumbago ===
                          item.VALUE
                        }
                        disabled={false}
                      />
                    );
                  })}
                </div>
              )}
            </FormElement>
          </FormListItem>
        )}

        {formValues.anamnesis_type !== EXISTANCE_FLAG.EXIST.VALUE ? null : (
          <FormListItem label='熱中症' safetyDocItem={true}>
            <FormElement>
              {disabledAll ? (
                <RadioText
                  name='common'
                  value={formValues.anamnesis_detail_type_heatstroke}
                  disabled={true}
                />
              ) : (
                <div className='form-list-radio'>
                  {_.map(EXISTANCE_FLAG, (item, i) => {
                    return (
                      <FormRadio
                        key={`anamnesis_detail_type_heatstroke${String(i)}`}
                        label={item.TEXT}
                        name='anamnesis_detail_type_heatstroke'
                        value={item.VALUE}
                        events={events}
                        checked={
                          formValues.anamnesis_detail_type_heatstroke ===
                          item.VALUE
                        }
                        disabled={false}
                      />
                    );
                  })}
                </div>
              )}
            </FormElement>
          </FormListItem>
        )}

        {formValues.anamnesis_type !== EXISTANCE_FLAG.EXIST.VALUE ? null : (
          <FormListItem label='その他' safetyDocItem={true}>
            <FormElement validate={messages[name]}>
              <WorkerInputText
                name='anamnesis_etc'
                value={formValues.anamnesis_etc}
                onChange={e => {
                  events.setValueAnamneses(e.target.name, e.target.value);
                }}
                disabled={disabledAll}
                maxLength={255}
              />
            </FormElement>
          </FormListItem>
        )}
      </FormList>
    </div>
  );
};
export default AnamnesesForm;



// WEBPACK FOOTER //
// ./src/components/worker/form/AnamnesesForm.jsx